import * as Constants from './constants'

export const giaoHangReportListRequest = function giaoHangReportListRequest(formData) {
  return {
    type: Constants.GIAOHANG_REPORT_LIST_REQUESTING,
    payload: formData
  }
}

export const giaoHangReportListSuccess = function giaoHangReportListSuccess(data) {
  return {
    type: Constants.GIAOHANG_REPORT_LIST_SUCCESS,
    data
  }
}

export const giaoHangReportListError = function giaoHangReportListError(error) {
  return {
    type: Constants.GIAOHANG_REPORT_LIST_ERROR,
    error
  }
}

export const giaoHangReportListNvRequest = function giaoHangReportListNvRequest (formData, callback) {  
  return {
    type: Constants.GIAOHANG_REPORT_LIST_NV_REQUESTING,
    formData,
    callback
  }
}

export const giaoHangReportListNvSuccess = function giaoHangReportListNvSuccess (data) {  
  return {
    type: Constants.GIAOHANG_REPORT_LIST_NV_SUCCESS,
    data
  }
}

export const giaoHangReportListNvError = function giaoHangReportListNvError (error) {  
  return {
    type: Constants.GIAOHANG_REPORT_LIST_NV_ERROR,
    error
  }
}

export const giaoHangReportExportXlsRequest = (formData, onSuccess) => {
  return {
    type: Constants.GIAOHANG_REPORT_EXPORT_XLS_REQUESTING,
    payload: formData,
    onSuccess
  }
}

export const giaoHangReportExportXlsSuccess = () => {
  return {
    type: Constants.GIAOHANG_REPORT_EXPORT_XLS_SUCCESS,
  }
}

export const giaoHangReportExportXlsError = function giaohangExportXlsError(error) {
  return {
    type: Constants.GIAOHANG_REPORT_EXPORT_XLS_ERROR,
    error
  }
}



// WEBPACK FOOTER //
// ./src/views/Reports/GiaoHangReport/actions.js